import { styled } from '@mui/material';
import CTAButton from '@components/CTAButton';

export const Overlay = styled('div')({
  position: 'fixed',
  inset: 0,
  zIndex: 1300,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
});

export const Card = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '30px 30px 18px',
  borderRadius: 4,
  width: 480,
  backgroundColor: theme.palette.novotalk.$backgroundColor || '#fff',
  boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
}));

export const IconWrapper = styled('div')({
  marginBottom: 16,
  display: 'flex',
  justifyContent: 'center',
});

export const Body = styled('div')({
  minWidth: 300,
  maxWidth: 360,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  marginBottom: 28,
});

export const Buttons = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 0,
});

export const YesButton = styled(CTAButton)({
  width: 240,
  height: 52,
  borderRadius: 26,
  marginBottom: 14,
});
